import type { LandingPageConfigOptions } from "landing/objects/LandingPageConfig";

export const LandingPageTemplate15: LandingPageConfigOptions = {
  consentAge: 18,
};
